"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LMSLesson = exports.CompletionState = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
var CompletionState;
(function (CompletionState) {
    CompletionState[CompletionState["NotStarted"] = 0] = "NotStarted";
    CompletionState[CompletionState["Started"] = 1] = "Started";
    CompletionState[CompletionState["Done"] = 2] = "Done";
})(CompletionState = exports.CompletionState || (exports.CompletionState = {}));
class LMSLesson {
    constructor() {
        this.LessonInstance = undefined;
        this.HistoryObject = undefined;
        this.HistoryObjectTargetsOldVersion = false;
        this.Completion = CompletionState.NotStarted;
        this.Mandatory = false;
        this.IsSCORM = false;
        this.Tags = [];
    }
    static fromJSON(json) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let returnLessonModel = new LMSLesson();
            let instanceJSON = json["LessonInstance"];
            if (instanceJSON) {
                returnLessonModel.LessonInstance = yield Instance_1.Instance.fromJSON(instanceJSON);
            }
            instanceJSON = json["HistoryObject"];
            if (instanceJSON) {
                returnLessonModel.HistoryObject = yield Instance_1.Instance.fromJSON(instanceJSON);
            }
            returnLessonModel.HistoryObjectTargetsOldVersion = json["HistoryObjectTargetsOldVersion"];
            returnLessonModel.Completion = json["Completion"];
            returnLessonModel.Mandatory = json["Mandatory"];
            returnLessonModel.IsSCORM = json["IsSCORM"];
            returnLessonModel.Tags = json["Tags"];
            return returnLessonModel;
        });
    }
    static fromJSONArray(json) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let lessonsReturn = [];
            for (let lessonJSON of json) {
                lessonsReturn.push(yield LMSLesson.fromJSON(lessonJSON));
            }
            return lessonsReturn;
        });
    }
    clone() {
        let returnLessonModel = new LMSLesson();
        if (this.LessonInstance)
            returnLessonModel.LessonInstance = this.LessonInstance.clone();
        ;
        if (this.HistoryObject)
            returnLessonModel.HistoryObject = this.HistoryObject.clone();
        returnLessonModel.HistoryObjectTargetsOldVersion = this.HistoryObjectTargetsOldVersion;
        returnLessonModel.Completion = this.Completion;
        returnLessonModel.Mandatory = this.Mandatory;
        returnLessonModel.IsSCORM = this.IsSCORM;
        returnLessonModel.Tags = this.Tags;
        return returnLessonModel;
    }
    toJSON() {
        let jsonObject = {};
        if (this.LessonInstance) {
            jsonObject["LessonInstance"] = this.LessonInstance.toJSON();
        }
        if (this.HistoryObject) {
            jsonObject["HistoryObject"] = this.HistoryObject.toJSON();
        }
        jsonObject["HistoryObjectTargetsOldVersion"] = this.HistoryObjectTargetsOldVersion;
        jsonObject["Completion"] = this.Completion;
        jsonObject["Mandatory"] = this.Mandatory;
        jsonObject["IsSCORM"] = this.IsSCORM;
        jsonObject["Tags"] = this.Tags;
        return jsonObject;
    }
    ;
}
exports.LMSLesson = LMSLesson;
